import { AnyObjectSchema } from 'yup';

import {
  Box,
  FormValues,
  dialogGrid,
  getDialogBodySx,
  useTheme,
} from '@sbv-clients/ui-shared';

import { Form } from '../form/form';
import { SubmitActions } from './dynamic-form-actions';
import { DynamicField } from './dynamic-form-body';
import { buildSchemaFromFields } from './dynamic-form-schema';
import { prepareDefaultValues } from './prepare-default-values';

export interface DynamicFormProps {
  fields: any[];
  onSubmit: FormValues<any>['onSubmit'];
  onCancel: () => void;
  defaultValues?: Record<string, any>;
}

const DynamicFormFields = ({ fields }: { fields: any[] }) => {
  const theme = useTheme();
  return (
    <Box sx={getDialogBodySx(theme)}>
      <Box sx={dialogGrid(2, '14px', 340)}>
        {fields.map((f: any) => (
          <DynamicField fieldDef={f} key={f.field} />
        ))}
      </Box>
    </Box>
  );
};

export function DynamicForm({
  fields,
  onSubmit,
  onCancel,
  defaultValues: userDefaultValues = {},
}: DynamicFormProps) {
  const schema = buildSchemaFromFields(fields) as AnyObjectSchema;
  const defaultValues = userDefaultValues || prepareDefaultValues(fields, {});
  return (
    <Form schema={schema} defaultValues={defaultValues} onSubmit={onSubmit}>
      <DynamicFormFields fields={fields} />
      <SubmitActions onCancel={onCancel} />
    </Form>
  );
}
